import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const SystemAnalytics = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Sistem Analitikleri
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Sistem analitikleri burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default SystemAnalytics;
